import { render, staticRenderFns } from "./AddUltrasound.vue?vue&type=template&id=46257d41&scoped=true"
import script from "./AddUltrasound.vue?vue&type=script&lang=js"
export * from "./AddUltrasound.vue?vue&type=script&lang=js"
import style0 from "./AddUltrasound.vue?vue&type=style&index=0&id=46257d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46257d41",
  null
  
)

export default component.exports